import React, { useEffect, useRef, useState } from 'react';
import { LockSimpleOpen, LockSimpleOpenActive, PersonalIcon, PersonalIconActive } from 'assets/images/web-isn';
import { useHistory, useParams } from 'react-router';
import { getUserProfile, postChangeProfile } from '../accountPage.api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import * as action from '../accountPage.action';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function ManageAccountLeft(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const history = useHistory();
  const { language } = useParams();
  const authUserData = JSON.parse(localStorage.getItem('authUserData'));
  const [changeInfo, setChangeInfo] = useState(false);

  const handlePersonalDetails = () => {
    history.push(`/${language}/manage-account/personal-detail`);
  };

  const handleChangePassword = () => {
    history.push(`/${language}/manage-account/change-password`);
  };

  const fileInputRef = useRef();

  const handleChange = e => {
    const imageSize = e.currentTarget.files[0]?.size;
    const imageUrl = e.currentTarget.files[0];

    if (imageSize < 2.5e6) {
      let FormData = require('form-data');
      let data = new FormData();

      data.append('Images', imageUrl);

      postChangeProfile(data).then(res => {
        if (res.status === 'success') {
          onSuccess();
          setChangeInfo(!changeInfo);
          props.fetchAccountInfo();
        }
      });
    } else {
      onError();
      fileInputRef.current.value = '';
    }
  };

  const [userData, setUserData] = useState({});

  useEffect(() => {
    showLoader();
    getUserProfile().then(res => {
      if (res) {
        setUserData(res);

        const newAuthUserData = {
          ...authUserData,
          userInfo: {
            ...authUserData.userInfo,
            imageUrl: res.imageUrl,
          },
        };

        localStorage.setItem('authUserData', JSON.stringify(newAuthUserData));
      }
      hideLoader();
    });
    //eslint-disable-next-line
  }, [changeInfo]);

  const messageSuccess = (
    <>
      <div>{t('manage_account.label_successAvatar')}</div>
    </>
  );

  const messageError = (
    <>
      <div>{t('manage_account.label_errorImage')}</div>
    </>
  );

  const onSuccess = () => {
    toast.success(messageSuccess, { autoClose: 5000 });
  };
  const onError = () => {
    toast.error(messageError, { autoClose: 5000 });
  };

  return (
    <div className="col-12 col-md-4 pl-0 pr-md-3 pr-0 mb-4 mb-md-0">
      <div className="personal-detail__left">
        <div className="personal-detail__left-avatar">
          <img src={userData.imageUrl} alt="avatar" />
        </div>
        <div className="personal-detail__left-name pb-2">
          {authUserData?.userInfo?.fullName === undefined ? '' : authUserData?.userInfo?.fullName}
        </div>
        <button className="personal-detail__left-change_avatar" onClick={() => fileInputRef.current.click()}>
          {t('manageAccount.label_changeAvatar')}
        </button>
        <input
          onChange={e => handleChange(e)}
          multiple={false}
          ref={fileInputRef}
          type="file"
          accept="image/jpeg, image/png, image/jpg, image/gif, image/tiff, image/bmp"
          hidden
        />
        <div className="pb-4">
          <div
            onClick={handlePersonalDetails}
            className={`personal-detail__left-personal_detail ${
              window.location.href.includes('/personal-detail') ? 'personal-detail__left-span-active' : ''
            }`}
          >
            <img
              className="pr-3"
              src={window.location.href.includes('/personal-detail') ? PersonalIconActive : PersonalIcon}
              alt="personal-icon"
            />
            <span>{t('manageAccount.label_personalDeail')}</span>
          </div>
          {authUserData?.userInfo?.userId === null ? (
            ''
          ) : (
            <div
              onClick={handleChangePassword}
              className={`personal-detail__left-personal_detail mt-0 ${
                window.location.href.includes('/change-password') ? 'personal-detail__left-span-active' : ''
              }`}
            >
              <img
                className="pr-3"
                src={window.location.href.includes('/change-password') ? LockSimpleOpenActive : LockSimpleOpen}
                alt="lock-icon"
              />
              <span>{t('manageAccount.label_changePassword')}</span>
            </div>
          )}
        </div>
      </div>
      {loader}
    </div>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAccountInfo: action.fetchAccountInfo,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccountLeft);
